/**
 * Collects a GraphNode's children into a map indexed by their instanceId
 */
export const getGraphNodesByInstanceIds = <Node extends {instanceId: string; [Symbol.iterator]: () => Iterator<Node>}>(node: Node) => {
    const nodeMap = new Map<string, Node>()
    for (const subNode of node) {
        nodeMap.set(subNode.instanceId, subNode as Node)
    }
    return nodeMap
}
